import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useParams, useNavigate } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import { Button, Text, Small, Panel, H3, H4, Dropdown, Input, Tabs, Datepicker, Textarea, Box, Select } from '@bigcommerce/big-design';
import { AddIcon, ArrowDropDownIcon, AddCircleOutlineIcon, StoreIcon } from '@bigcommerce/big-design-icons';

import { zoneFind, zoneUpdate } from '../../redux/actions/zones';

const UpdateZoneForm = ({ payload, zones, newZone, loadZone, updateZone }) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const [submitted, setSubmitted] = useState(false);
  const [label, setLabel] = useState(null);
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState(1);

  useEffect(() => {
    console.log(id);
    loadZone(payload, id);
  }, []);

  useEffect(() => {
    if(newZone) { navigate(-1) };
  }, [newZone]);

  useEffect(() => {
    if(zones.activeZone) {
      setLabel(zones.activeZone.label);
      setDescription(zones.activeZone.description);
      setPriority(zones.activeZone.priority);
    }
  }, [zones]);

  const setDescriptionValue = (e) => {
    setDescription(e.target.value);
  }

  const setPriorityValue = (e) => {
    let priority = parseInt(e.target.value);
    setPriority(priority);
  }

  const submitZone = () => {
    // setSubmitted(true);
    updateZone(payload, id, label, description, priority);
  }

  const sectionDescription = () => {
    return(
      <>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  if(!zones.activeZone) {
    return (
      <>
        <PageHeader stripeBackground='#c66628' helpLink="" />
        <SettingsPage title="Update Zone" description={sectionDescription()}>
          <Panel>
            <H3>Update Zone</H3>

            <LoadingSpinner size="xxSmall" statusText="Loading zone" />

          </Panel>
        </SettingsPage>
      </>
    )
  }


  return(
    <>
      <PageHeader stripeBackground='#c66628' helpLink="" />
      <SettingsPage title="Update Zone" description={sectionDescription()}>
        <Panel>
          <H3>Update Zone</H3>

          <Input 
            required 
            label="Zone Name"
            placeholder="Zone Name"
            id="label" 
            type="text" 
            value={label} 
            onChange={(e) => setLabel(e.target.value)} 
          />

          <Input 
            required 
            label="Description"
            placeholder="Description"
            id="description" 
            type="text" 
            value={description} 
            onChange={(e) => setDescriptionValue(e)} 
          />

          <Input 
            required 
            label="Priority"
            placeholder="Priority"
            id="priority" 
            type="number" 
            min="1"
            value={priority} 
            onChange={(e) => setPriorityValue(e)} 
          />

        </Panel>

        <Panel>
          <Button 
            iconLeft={<AddIcon />}
            disabled={ submitted }
            onClick={() => submitZone() }
            isLoading={submitted}
          >
            Update Zone
          </Button>
        </Panel>

      </SettingsPage>
    </>
  )
}

const mapStateToProps = state => ({
  zones: state.zones,
  newZone: state.zones.newZone,
});

const mapDispatchToProps = (dispatch) => ({
  loadZone: (payload, id) => dispatch(zoneFind(payload, id)),
  updateZone: (payload, id, label, description, priority) => dispatch(zoneUpdate(payload, id, label, description, priority)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateZoneForm);